/**
 * Ordinary /login entry point.
 *
 * No request options are supplied: Auth0 keeps its normal login behaviour and
 * /callback resolves the user's role-default destination after authentication.
 * Guided signup is a separate /signup flow with request-scoped options.
 */
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useAuth0 } from '@auth0/auth0-react';

import LoadingSpinner from '@/components/common/LoadingSpinner';

function LoginRedirector() {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    loginWithRedirect();
  }, [loginWithRedirect]);

  return (
    <>
      <Helmet>
        <title>Sign In | DeepThink</title>
      </Helmet>
      <LoadingSpinner />
    </>
  );
}

export default LoginRedirector;
